import { patchRequest } from "../httpMethods";

export const patchBoardStatus = (id, payload) => patchRequest(`v1/sv/masters/board/${id}`, payload);
export const patchMediumStatus = (id, payload) => patchRequest(`v1/sv/masters/medium/${id}`, payload);
export const patchGradeStatus = (id, payload) => patchRequest(`v1/sv/masters/grade/${id}`, payload);
export const patchSectionStatus = (id, payload) => patchRequest(`v1/section/status/${id}`, payload);
